import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import {AaSequenceComplex} from 'molbio/aa-sequences/complex/AaSequenceComplexConstants';
import formatAminoAcids from 'molbio/aa-sequences/util/formatAminoAcids';

export default function AaSequenceChainPreview({name, aminoAcids}: AaSequenceComplex): JSX.Element {
  return (
    <div {...getTestProps({component: 'AaSequenceChainPreview', element: 'root'})}>
      <div>
        <strong {...getTestProps({component: 'AaSequenceChainPreview', element: 'name'})}>{name}</strong>
      </div>
      <pre {...getTestProps({component: 'AaSequenceChainPreview', element: 'residues'})}>
        {formatAminoAcids(aminoAcids)}
      </pre>
    </div>
  );
}
